import { IconDefinition } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface TerminInfoRowProps extends React.HTMLAttributes<HTMLDivElement> {
  icon: IconDefinition;
  children: React.ReactNode;
}

export function TerminInfoRow({
  icon,
  children,
  className,
  ...divProps
}: TerminInfoRowProps) {
  return (
    <div
      className={`flex items-center gap-3 overflow-hidden text-start ${className ?? ''}`}
      {...divProps}>
      <FontAwesomeIcon icon={icon} widthAuto />
      <div className="min-w-0">{children}</div>
    </div>
  );
}
